import api from '@/apis'

export const getCurrentUser = () => api.get(`/users/profile`)
